import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import type { Scope } from '@sentry/react';
import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import { isNetworkError } from '../../api/apiClient';
import { useLogger } from '../../hooks/useLogger';
import { getCurrentUser } from '../../utils/currentUser';
import { ErrorPage } from './errorPage';

export const CustomErrorBoundary = ({ children }: { children: ReactNode }) => {
    const logger = useLogger();

    return (
        <Sentry.ErrorBoundary
            beforeCapture={(
                _: Scope,
                error: unknown,
                componentStack?: string,
            ) => {
                // Skips only the SumoLogic/console logging — Sentry capture
                // itself is filtered out in beforeSend (see config/sentry.ts).
                if (isNetworkError(error)) {
                    return;
                }
                const { id: userId, email: userEmail } = getCurrentUser();
                console.log(error);
                console.log(componentStack);
                if (error instanceof Error) {
                    logger.error('Error caught by ErrorBoundary', error, {
                        errorInfo: { componentStack },
                        timestamp: Date.now(),
                        userEmail,
                        userId,
                    });
                } else {
                    logger.error(
                        `Error caught by ErrorBoundary: ${JSON.stringify(error)}`,
                        { name: '', message: '' },
                        {
                            errorInfo: { componentStack },
                            timestamp: Date.now(),
                            userEmail,
                            userId,
                        },
                    );
                }
            }}
            fallback={({ error }) =>
                isNetworkError(error) ? (
                    <ErrorPage
                        title={'error_occured'}
                        message={'connection_error'}
                        isTransient
                        action={{
                            label: 'try_again',
                            icon: <RefreshOutlinedIcon />,
                            onClick: () => window.location.reload(),
                        }}
                    />
                ) : (
                    <ErrorPage
                        title={'error_occured'}
                        message={'unknown_error'}
                    />
                )
            }
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};
